/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoverPhotoFull
 */
export interface CoverPhotoFull {
    /**
     * 
     * @type {string}
     * @memberof CoverPhotoFull
     */
    _640x?: string;
    /**
     * 
     * @type {string}
     * @memberof CoverPhotoFull
     */
    _2000x?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CoverPhotoFull
     */
    mirrors?: Array<string>;
}

/**
 * Check if a given object implements the CoverPhotoFull interface.
 */
export function instanceOfCoverPhotoFull(value: object): value is CoverPhotoFull {
    let isInstance = true;

    return isInstance;
}

export function CoverPhotoFullFromJSON(json: any): CoverPhotoFull {
    return CoverPhotoFullFromJSONTyped(json, false);
}

export function CoverPhotoFullFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoverPhotoFull {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        '_640x': !exists(json, '640x') ? undefined : json['640x'],
        '_2000x': !exists(json, '2000x') ? undefined : json['2000x'],
        'mirrors': !exists(json, 'mirrors') ? undefined : json['mirrors'],
    };
}

export function CoverPhotoFullToJSON(value?: CoverPhotoFull | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        '640x': value._640x,
        '2000x': value._2000x,
        'mirrors': value.mirrors,
    };
}

